<template>
  <div id="walletConfigPage">
    <form @submit.prevent="submit">
      <img id="mp_logo" src="@/assets/MontyPay.png" alt="MontyPay" />

      <label class="field">
        <span>Merchant Key</span>
        <input v-model="merchantKey" type="text" placeholder="Merchant Key" />
      </label>
      <label class="field">
        <span>Merchant Password</span>
        <input
          v-model="merchantPassword"
          type="text"
          placeholder="Configuration Password"
        />
      </label>
      <label class="field">
        <span>API Key</span>
        <input v-model="apiKey" type="text" placeholder="API Key" />
      </label>

      <button id="save" type="submit">Submit</button>
    </form>
  </div>
</template>

<script>
import axios from "axios";

export default {
  name: "WalletConfigurationPage",
  data() {
    return {
      errorState: false,
      errorMsg: "",
      loading: true,
      apiKey: "",
      merchantPassword: "",
      shop: "",
      domain: "",
      config: {},
      session: {},
      merchantKey: "",
    };
  },
  methods: {
    async getData(shop, domain) {
      const target = encodeURIComponent(shop || domain);
      // A 404 here means the merchant has not saved a wallet configuration yet
      // (first install, or after /wallet/uninstall); the form just starts empty.
      const config = await axios
        .get(`/wallet/configuration/get?shop=${target}`)
        .then((resp) => resp.data)
        .catch((err) => {
          if (err.response?.status !== 404) {
            console.log(
              "Error in getting Config:",
              err.response?.data ?? err.message,
            );
          }
          return null;
        });
      const session = await axios
        .get(`/wallet/session/get?shop=${target}`)
        .then((resp) => resp.data)
        .catch((err) => {
          console.log(
            "Error in getting Session:",
            err.response?.data ?? err.message,
          );
          return null;
        });

      this.config = config || {};
      this.session = session || {};
      return { config: this.config, session: this.session };
    },
    async submit() {
      await axios
        .post("/wallet/configuration/update", {
          shop: this.$route.query.shop,
          apiKey: this.apiKey,
          merchantPassword: this.merchantPassword,
          merchantKey: this.merchantKey,
        })
        .then((resp) => {
          console.log("Resp:", resp.data);

          window.location.href = resp.data.redirect_url;
        })
        .catch((err) => {
          console.error(err);
          alert("Submition failed");
        });
    },
  },
  async mounted() {
    const shop = this.$route.query.shop;
    const domain = this.$route.query.domain;
    if (shop) {
      this.shop = shop;
      this.domain = domain;
      await this.getData(shop, domain);
      this.apiKey = this.config?.apiKey || "";
      this.merchantPassword = this.config?.merchantPassword || "";
      this.merchantKey = this.config?.merchantKey || "";
    }
  },
  beforeUnmount() {},
};
</script>

<!-- Styles are global in this app, so everything is nested under the page id. -->
<style lang="scss">
@use "../styles/brand" as *;
@import url("https://fonts.googleapis.com/css2?family=Manrope:wght@200..800&display=swap");

#walletConfigPage {
  min-height: 100dvh;
  width: calc(100vw - 8px);
  box-sizing: border-box;
  background-color: $bg-primary;
  display: flex;
  justify-content: center;
  align-items: center;

  * {
    background-color: transparent; // App.vue paints every element #f9fafb
    box-sizing: border-box;
    font-family: "Manrope", sans-serif;
  }

  form {
    width: 100%;
    max-width: 700px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background-color: $white;
    border: 1px solid $light-gray;
    border-radius: 22px;
    padding: 26px;
    overflow-x: hidden;
    margin: 2rem auto;

    #mp_logo {
      height: 50px;
      align-self: flex-start;
    }
    h1 {
      font-size: 28px;
      color: $black;
      margin: 0;
    }
    h2 {
      @include sub-menu();
      margin: 0.5rem 0 0;
    }
    .note {
      @include p();
      margin: 0;
    }

    .field {
      display: flex;
      flex-direction: column;
      gap: 6px;

      span {
        font-size: 12.5px;
        font-weight: 600;
        color: $dark-gray;
      }
      input,
      select {
        @include field-commons();
        width: 100%;
        font-size: 14px;
        color: $black;
        outline: none;

        &:focus {
          border-color: $primary;
        }
      }
    }

    #save {
      background-color: $primary;
      color: $white;
      width: 100%;
      height: 56px;
      border: 0;
      border-radius: 16px;
      font-size: 16px;
      font-weight: 600;
      letter-spacing: -0.01em;
      cursor: pointer;
      margin-top: 0.5rem;

      &:hover {
        background-color: $primary-dark;
      }
    }
  }
}

@media screen and (max-width: 450px) {
  #walletConfigPage form {
    padding: 20px;
  }
}
</style>
